import { render, staticRenderFns } from "./CommunityCards.vue?vue&type=template&id=12795c8f"
import script from "./CommunityCards.vue?vue&type=script&lang=js"
export * from "./CommunityCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports